// we need that so that after login and localstorage.clear we know where to redirect a user
let pendingRedirect: string | null = null;

export const setPendingRedirect = (path: string): void => {
  pendingRedirect = path;
};

export const consumePendingRedirect = (): string | null => {
  const path = pendingRedirect;
  pendingRedirect = null;
  return path;
};
